import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" {...this.props}><path fill="#EBEEEF" stroke="#5D615F" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M29.467 3.155l-11.18 10.312L7.107 3.155h22.36z" /><path fill="none" stroke="#5D615F" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeDasharray="5 4.5" d="M34.467 18.155H1.845" /><path fill="none" stroke="#5D615F" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M29.467 33.467l-11.18-10.312-11.18 10.312h22.36z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/assets/icons/flip-v.svg